const initSummerQuickSearchGoButton = () => {
  const goButton = document.getElementById('summerHomePageGoButton');
  const selectList = document.getElementById('summerQuickSearchSelectList');
  if (goButton && selectList) {
    goButton.addEventListener('click', e => {
      const url = selectList.options[selectList.selectedIndex].value;
      window.location.href = url;
    });
  }
};

export default initSummerQuickSearchGoButton;

